import InputGroup from "./input-group.component";

export default InputGroup;